import Home from "./pages/home/Home";
import PaymentMethodsHome from "./pages/paymentMethods/PaymentMethodsHome";

const routes = [
  {
    path: '/repuestos*',
    component: Home,
    exact: true
  },
  {
    path: '/pecas*',
    component: Home,
    exact: true
  },
  {
    path: '/medios-de-pago*',
    component: PaymentMethodsHome,
    exact: true
  }
];

export default routes;  